export namespace IProfile {

  export interface IState {
    profileData: DataProfile;
    defaultForm: IChangeableData;
    emailIsConfirm: boolean;
    refMode: boolean;
    refCode: string;
  }

  export const STATUS_ERROR_PASSWORD_NOT_CONFIRMED = 481;
  export const STATUS_ERROR_EMAIL_NOT_CONFIRMED = 482;
  export const STATUS_ERROR_USER_IS_EXIST_IN_DB = 472;

  export interface DataProfile {
    inn: string;
    confirmEmail: string;
    extModeFlag: boolean;
    surName: string;
    firstName: string;
    middleName: string;
    email: string;
    phone: string;
    parkChoice: string[];
    carsXParksFlag: boolean;
    corpName: string;
    company?: string;
    password?: string;
    contact?: string;
  }

  export interface IChangeableData {
    surName: string;
    firstName: string;
    middleName: string;
    email: string;
    phone: string;
    parkChoice: string[];
    extModeFlag: boolean;
    carsXParksFlag: boolean;
    password: boolean;
  }

  export interface DataChangePassword {
    oldPassword: string;
    newPassword: string;
    email: string;
  }

  export enum PageTab {
    Form = 'form',
    Payment = 'payment',
    Theme = 'theme',
    Accounts = 'accounts',
  }

  export interface OutputData {}

  /* Result data structure */

  export interface ResourceGetResponseDataResult extends DataProfile {}

  export interface ResourceChangePasswordResponseDataResult extends DataChangePassword {}

  export interface ResourceSubmitResponseDataResult {}
}
